import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../hooks/hooks";
import { RootState } from "../redux/store";
import { buildLoginPath } from "../utils/returnPath";

interface Props {
    children: React.ReactNode;
}

// localStorage access can throw (Safari private browsing, storage disabled by
// policy); treat that as "no token", the same way ProtectedRoute does.
const readStoredToken = (): string | null => {
    try {
        return localStorage.getItem("access_token");
    } catch {
        return null;
    }
};

const P3MSuperAdminRoute: React.FC<Props> = ({ children }) => {
    const user = useAppSelector((state: RootState) => state.auth.user);
    const isp3mSuperAdmin = useAppSelector(
        (state: RootState) => state.auth.p3mSuperAdminMode
    );
    const location = useLocation();

    // Same shape as AdminRoute. `p3mSuperAdminMode` is false on a hard refresh
    // until `loaduser` resolves, so decide nothing while a stored token exists
    // and the profile is still loading. (A fixed timer here used to race that
    // fetch and bounce slow loads to login, which then forwarded to Home.)
    const token = readStoredToken();

    if (token && !user) {
        return <div>Loading...</div>;
    }

    if (isp3mSuperAdmin) {
        return <>{children}</>;
    }

    // Signed in without the role: Home, never login (login would forward an
    // authenticated user straight back here and loop).
    if (user) {
        return <Navigate to="/" replace={true} />;
    }

    return <Navigate to={buildLoginPath(location)} replace={true} />;
};

export default P3MSuperAdminRoute;
